import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { Container } from "react-bootstrap";
import SingleInput from "../UI/SingleInput";
import { ShowNotification } from "../../services/Notifications";
import DragableMap from "../UI/DragableMap";
import { getStorage, setStorage } from "../../services/localStorageService";
import ServiceCenterRequest from "../../services/ServiceCenterRequest";
import { fileValidation } from "../../guards/guards";
import { getImageURL } from "../../configs/common";
import TaskManagerRequest from "../../services/TaskManagerRequest";
const DRIVER_DEFAULT_PROFILE =
  require("../../assets/images/avatar-men.png").default;

const EditReservationProfile = (props) => {
  //
  const imagePicker = useRef(null);
  const fleetReserveData = getStorage("__fleetReservation__", "object");

 
  const [editFormData, setEditFormData] = useState({
    organization: "",
    username: "",
    email: "",
  });

  const [profileURL, setProfileURL] = useState(DRIVER_DEFAULT_PROFILE);
  const [file, setFile] = useState(false);

  const onChangeForm = (e, name) => {
    var clone = { ...editFormData };
    clone[name] = e.target.value;
    setEditFormData(clone);
  };

  const onEditCenter = async (event) => {
    const formData = new FormData();
    event.preventDefault();

    Object.keys(editFormData).map((key) => {
      formData.append(key, editFormData[key]);
    });

  
    if (file) formData.append("profileImage", file);
    for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      console.log("file is ",file);
      
    try {
      const response = await TaskManagerRequest(
        "/fleet/edit/profile",
        formData,
       
      );
      setStorage(
        "__fleetReservation__",
        { ...response, token: fleetReserveData.token },
        "object"
      );
      event.target.reset();
      setEditFormData({
        organization: "",
        username: "",
        email: "",
      });
      setProfileURL(DRIVER_DEFAULT_PROFILE);
      ShowNotification("success", "User Details Edited successfully");
      props.toggleModal();
    } catch (error) {
      ShowNotification("error", error);
    } finally {
    }
  };

  useEffect(() => {
    if (!file) {
      setProfileURL(DRIVER_DEFAULT_PROFILE);
      return false;
    }

    if (fileValidation(file.name) !== true) {
      ShowNotification("error", "Please select image only!");
      return false;
    }

    setProfileURL(window.URL.createObjectURL(file));
  }, [file]);

  useEffect(() => {
    if (props.show && fleetReserveData) {
      setEditFormData({
        organization: fleetReserveData.organization,
        username: fleetReserveData.username,
        email: fleetReserveData.email,
    
      });
      
      if (
        fleetReserveData.profileImage &&
        fleetReserveData.profileImage !== ""
      ) {
        setProfileURL(getImageURL(fleetReserveData.profileImage, "/"));
      } else {
        setProfileURL(DRIVER_DEFAULT_PROFILE);
      }
    }
  }, [props.show]);

  return (
    <>
      <Modal
        show={props.show}
        dialogClassName="modal-40w"
        onHide={props.toggleModal}
        aria-labelledby="attendanceMap"
      >
        <Modal.Header closeButton>
          Profile - {fleetReserveData.organization}
        </Modal.Header>

        <form onSubmit={onEditCenter}>
          <Modal.Body className="show-grid">
            <Container>
              <div className="row text-start">
                <div className="col-md-12 text-center">
                  <img
                    onClick={() => {
                      imagePicker.current.click();
                    }}
                    className="ad-driver-image"
                    style={{ border: "1px solid #d9e5fb" }}
                    src={profileURL}
                    alt=""
                  />
                  <input
                    accept="image/png, image/gif, image/jpeg, image/jpg"
                    onChange={(e) => setFile(e.target.files[0])}
                    ref={imagePicker}
                    type="file"
                    className="hidden"
                  />
                </div>
                <div className="col-md-6">
                  <p className="label font-12 mb-1 mt-3">Organization Number</p>
                  <SingleInput
                    onChange={(e) => onChangeForm(e, "organization")}
                    value={editFormData.organization}
                    name="organization"
                    placeholder="organization number"
                  />
                </div>

                <div className="col-md-6">
                  <p className="label font-12 mb-1 mt-3">Contact Name</p>
                  <SingleInput
                    onChange={(e) => onChangeForm(e, "username")}
                    value={editFormData.username}
                    name="username"
                    placeholder="Contact Name"
                  />
                </div>

              

                <div className="col-md-6">
                  <p className="label font-12 mb-1 mt-3">Email ( username )</p>
                  <SingleInput
                    onChange={(e) => onChangeForm(e, "email")}
                    value={editFormData.email}
                    type="email"
                    name="email"
                    placeholder="Email"
                  />
                </div>

                

                
              </div>
            </Container>
          </Modal.Body>

          <Modal.Footer>
            <button
              type="button"
              className="btn btn-small font-12"
              onClick={props.toggleModal}
            >
              Close
            </button>
            <button
              id="edit-center"
              style={{ backgroundColor: "#007bff" }}
              className="btn btn-small font-12 text-white"
            >
              Edit
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default EditReservationProfile;